var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 7.33561C8.36852 7.33561 8.66699 7.63409 8.66699 8.00228V10.6689C8.66699 11.0371 8.36852 11.3356 8.00033 11.3356C7.63213 11.3356 7.33366 11.0371 7.33366 10.6689V8.00228C7.33366 7.63409 7.63213 7.33561 8.00033 7.33561Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 4.66895C7.63213 4.66895 7.33366 4.96742 7.33366 5.33561C7.33366 5.7038 7.63213 6.00228 8.00033 6.00228H8.00699C8.37518 6.00228 8.67366 5.7038 8.67366 5.33561C8.67366 4.96742 8.37518 4.66895 8.00699 4.66895H8.00033Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 8.00228C0.666992 3.95219 3.95024 0.668945 8.00033 0.668945C12.0504 0.668945 15.3337 3.95219 15.3337 8.00228C15.3337 12.0524 12.0504 15.3356 8.00033 15.3356C3.95024 15.3356 0.666992 12.0524 0.666992 8.00228ZM8.00033 2.00228C4.68662 2.00228 2.00033 4.68857 2.00033 8.00228C2.00033 11.316 4.68662 14.0023 8.00033 14.0023C11.314 14.0023 14.0003 11.316 14.0003 8.00228C14.0003 4.68857 11.314 2.00228 8.00033 2.00228Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4e5c6b728fee48ea95f8230a6eb38d69.svg";
export { ForwardRef as ReactComponent };